export function formatDateCST(date: Date): string {
  return `${Intl.DateTimeFormat('en-US', {
    dateStyle: 'short',
    timeStyle: 'medium',
    hourCycle: 'h24',
    timeZone: 'CST',
  }).format(date).replace(/,/g, '')} - CST`
}
